const Expand = require('../components/togglers/Expand');
const waiNotify = require('../components/waiNotify');
var billingHelpers = require('../checkout/billing');
let promoDisclosure;
const $input = $('.js-coupon-code-field');
const $errors = $('.js-promo-code-form-validation-messages');

function promoCodeFormClear() {
    $input.val('');
    $input.removeClass('is-invalid');
    $errors.hide();
}

function promoCodeFormSubmit(e) {
    e.preventDefault();
    $input.val($input.val().trim());
    const $form = $(e.target);

    $form.spinner().start();
    $input.removeClass('is-invalid');
    $errors.hide();

    const message = $form.data('action-message');

    $.ajax({
        url: $form.attr('action'),
        type: 'GET',
        dataType: 'json',
        data: $form.serialize(),
        success(data) {
            if (data.error) {
                $input
                    .addClass('is-invalid')
                    .attr('aria-describedby', 'promo-code-form-validation-messages');
                $errors
                    .show();
            } else {
                $('body')
                    .trigger('basket:update:promos', data.totals.discountsHtml)
                    .trigger('basket:update:totals', data)
                    .trigger('basket:update:discounts', { discounts: data.approachingDiscounts })
                    .trigger('basket:validate', data);
                promoDisclosure.close();
                $input.val('');
                waiNotify(message);
                billingHelpers.methods.updateGiftCardContainer(data);
                billingHelpers.methods.updateBillingLook(data);
            }
            $form.spinner().stop();
        },
        error(err) {
            if (err.responseJSON.redirectUrl) {
                window.window.location.href = err.responseJSON.redirectUrl;
            } else {
                $('body').trigger('basket:notify', err.errorMessage);
                $form.spinner().stop();
            }
        }
    });
}

function showModal (e) {
    e.preventDefault();
    let $modalContainer = $($('.js-coupon-error-modal').html());
    $('body').append($modalContainer);
    window.dialogManager.openDialog('modal', '#promo-modal-messages');
}

module.exports = function () {
    $('#promo-code-form').submit(promoCodeFormSubmit);
    $('body').on('click', '.js-promo-modal-link', showModal);
    $('.js-promo-code-button').each((_, promoDisclosureButton) => {
        promoDisclosure = new Expand(promoDisclosureButton);
        promoDisclosure.init();
        promoDisclosureButton.addEventListener('toggle:close', promoCodeFormClear);
    });

    $('body').on('coupon:form:clear', promoCodeFormClear);
};
